import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { Loading } from '../../common/Loading';

const formatTimestamp = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleString();
};

const ellipsisStyle = {
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const StatusBadge = ({ code }) => {
  const style = {
    display: 'inline-block',
    padding: '2px 6px',
    borderRadius: '3px',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    backgroundColor: code <= 299 ? '#5cb85c' : '#d9534f',
  };
  return <span style={style}>{code}</span>;
};

const DeliveryLogModal = ({ show, alert, entries, isLoading, error, onClose, onRetry }) => (
  <Modal show={show} onHide={onClose} bsSize="large">
    <Modal.Header closeButton>
      <Modal.Title>
        Webhook Delivery Log {alert && `\u2014 ${alert.name}`}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isLoading && <Loading show type="bar" />}
      {error && !isLoading && (
        <p>
          Failed to load delivery log.{' '}
          <a href="#" onClick={(e) => { e.preventDefault(); onRetry(); }}>
            Retry
          </a>
        </p>
      )}
      {!isLoading && !error && entries.length === 0 && (
        <p><em>No webhook deliveries recorded yet.</em></p>
      )}
      {!isLoading && !error && entries.length > 0 && (
        <table className="table table-condensed">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>URL</th>
              <th>Status</th>
              <th>Response</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(entry => (
              <tr key={entry.id}>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {formatTimestamp(entry.timestamp)}
                </td>
                <td style={ellipsisStyle} title={entry.webhook_url}>
                  {entry.webhook_url}
                </td>
                <td>
                  <StatusBadge code={entry.response_status_code} />
                </td>
                <td style={ellipsisStyle} title={entry.response_text}>
                  {entry.response_text}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);

DeliveryLogModal.defaultProps = {
  show: false,
  alert: null,
  entries: [],
  isLoading: false,
  error: null,
};

DeliveryLogModal.propTypes = {
  show: PropTypes.bool,
  alert: PropTypes.object,
  entries: PropTypes.array,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default DeliveryLogModal;



// WEBPACK FOOTER //
// ./src/components/searchAlerts/CustomAlerts/DeliveryLogModal.jsx